import { apiRequest } from "../util/apiUtils";

export const bannerList = async (params) => {
  try {
    const res = await apiRequest("get", `banner/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const bannerDetails = async (params) => {
  try {
    const res = await apiRequest("get", `banner/details/${params.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const bannerAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `banner/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const bannerDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `banner/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const bannerStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `banner/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
